import useLazySelector from "common/redux/useLazySelector";
import { UnitConversionRate } from "domain/unit";
import { loadUnitsCustomConversionRates } from "./units.actions";

const defaultVal: UnitConversionRate[] = [];
export default function useUnitConversionRates(): UnitConversionRate[] {
    return useLazySelector(store => store.unitsConversionRates, dispatch => loadUnitsCustomConversionRates(dispatch), null, defaultVal);
}